import { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../common/html/button'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { Tooltip } from '../../../../common/tooltip'
import {
  CANCELED_STATUS,
  COMPLETED_STATUS,
} from '../../orderManagement/constants'
import { postCancelRequestOrder } from '../store/thunk'
import classes from './index.module.scss'

export const CancelBtn = ({ snpOrderId, requestedToCancel, requestStatus }) => {
  const dispatch = useDispatch()

  const [isShowCancelPopup, setIsShowCancelPopup] = useState(false)

  const handleCancel = () => {
    setIsShowCancelPopup(true)
  }

  const handleCloseCancelPopup = () => {
    setIsShowCancelPopup(false)
  }

  const handleConfirmCancel = () => {
    dispatch(postCancelRequestOrder({ snpOrderId }))
      .unwrap()
      .then(() => setIsShowCancelPopup(false))
  }

  const isDisabled =
    requestStatus === CANCELED_STATUS ||
    requestStatus === COMPLETED_STATUS ||
    requestedToCancel

  return (
    <Fragment>
      <div style={{ marginRight: 20 }}>
        <Tooltip
          tooltipContent="userManagement.orderManagement.orderDetail.NOTE_CANCEL_BTN"
          isI18n
          tooltipStyle={{ width: 300 }}
        >
          <Button
            label="userManagement.packageSubManagement.CANCEL_REQUEST"
            style={{
              border: 'none',
              marginRight: 20,
              padding: '6px 12px',
              borderRadius: 4,
              cursor: 'pointer',
            }}
            disabled={isDisabled}
            action={handleCancel}
            isI18n
          />
        </Tooltip>
      </div>
      <PopupAction
        isShow={isShowCancelPopup}
        title="userManagement.packageSubManagement.CANCEL_REQUEST"
        btnCancel={{
          label: 'common.NO',
          isI18n: true,
          event: handleCloseCancelPopup,
        }}
        btnSubmit={{
          label: 'common.YES',
          isI18n: true,
          event: handleConfirmCancel,
        }}
        handleClose={handleCloseCancelPopup}
      >
        <div className={classes.popupContainer}>
          <Icon
            className="icon-alert"
            style={{ color: '#E8B714', fontSize: 38 }}
          />
          <div className={classes.messageContainer}>
            <Translate value="userManagement.packageSubManagement.CANCEL_QUESTION" />
          </div>
        </div>
      </PopupAction>
    </Fragment>
  )
}
